<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>
<alert-box (clicked)="showErrorPopup = !showErrorPopup" [hasImage]="errorData.hasImage"
    [headerMessage]="(errorData.headerMessage || '') | translate" [imageName]="errorData.imageName"
    [message]="errorData.message | translate" [visible]="showErrorPopup">
</alert-box>